import { render } from "./TasksApp.vue?vue&type=template&id=a00e19aa"
import script from "./TasksApp.vue?vue&type=script&lang=js"
export * from "./TasksApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__